var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "completed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-7-Copy-2",
    fill: "#7ADD60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7544594,7.25552431 C15.7055707,7.3944126 15.6211267,7.52996758 15.5222382,7.62996714 C13.6789128,9.47884807 11.7366989,11.422173 9.41004229,13.742163 C9.22226532,13.92994 9.02004396,14.0232729 8.81893372,14.0232729 C8.61560126,14.0232729 8.41337991,13.9288289 8.22449183,13.7399408 C7.05227466,12.5721681 5.83116881,11.3532844 4.49228568,10.011068 C4.11006511,9.62662521 4.10784289,9.19996038 4.48895236,8.80885096 C4.547841,8.74885122 4.61117406,8.68662926 4.68006265,8.61996288 C5.06561655,8.24552005 5.48783695,8.24774226 5.86672421,8.62440731 C6.81227569,9.56773658 7.76782713,10.5221769 8.70226756,11.4621729 C8.75226734,11.5121726 8.78560053,11.5721724 8.81448929,11.6266166 C8.81448929,11.6266166 8.81448929,11.6266166 8.8156004,11.6266166 L8.82893368,11.6055056 C8.86448908,11.5499503 8.90115559,11.4921727 8.95226648,11.4410618 C10.5900372,9.80106891 12.2578078,8.13440942 13.868912,6.52330524 L14.0622445,6.33108385 C14.5344647,5.85775255 14.924463,5.85886366 15.4066831,6.33330606 C15.6166822,6.54108294 15.9044588,6.82552616 15.7544594,7.25552431 M10.0033731,-1.24344979e-14 C4.45561917,0.0322220835 0.0223049319,4.4433142 8.28054048e-05,9.96217932 C-0.0221393211,15.5277109 4.43117484,19.9932472 9.98559536,19.9999139 C15.5477936,20.0065805 19.9944412,15.5588219 19.9999967,10.0121791 C20.0044411,4.44775863 15.541127,0.0333331898 10.0033731,-1.24344979e-14",
    id: "Fill-7-Copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.4f3438f0ec02e6a92818b4d92023615b.svg";
export { ForwardRef as ReactComponent };